import React, { Component } from 'react';

class InputPassword extends Component {
	render() {
		return <input placeholder = {this.props.placeholder}
			type = 'password'
			autoComplete = 'off'
			autoCorrect  = 'off'
			autoCapitalize = 'off'
			spellCheck = 'false'
			attr = {this.props.attr}
			onChange = {this.props.onChange}
			onKeyUp = {this.props.onKeyUp}
			value = {this.props.value}
			className = 'pt-fill pt-large pt-input'
		/>
	}
}

export default InputPassword;



// WEBPACK FOOTER //
// ./src/components/login/InputPassword.js